<div class="header">
  <img class="icon" src="assets/images/pfdIcon.svg" alt="PDF"/>
  <h3 class="title">{{ pfd.name }}, {{ pfd.fileNameWithoutExtension }}</h3>
</div>
<div class="button-wrapper">
  <button class="iconf-btn-blank minh40 minw150" (click)="openPfd.emit(pfd.code)">
    Open
    <fa-icon [icon]="faExternalLinkAlt"></fa-icon>
  </button>
  <button class="iconf-btn-filled minh40 minw150" (click)="downloadPfd.emit(pfd.code)">
    <fa-icon [icon]="faDownload"></fa-icon>
    Download
  </button>
</div>
